export default {
  contentView: {
    height: '100%',
    flex: 1,
    marginBottom: 80,
  },
  contentText: {},
};
